const SingleProduct = () => {

    // Get link params if clicked on product:

    const url_string = window.location.href;
    const url = new URL(url_string);
    const packageType = url.searchParams.get("package-type");
    const productType = url.searchParams.get("product-type");

    // Set active first product as active:

    const configureItem = document.querySelectorAll('.configure-item label input');
    const configureLabels = document.querySelectorAll('.configure-item label');
    const setPrice = document.getElementsByClassName('set-price')[0];

    if(packageType) {
        if(packageType === '6m') {
            configureItem[0].parentNode.classList.add('active');
            configureItem[0].checked = true;
            configureItem[1].parentNode.classList.remove('active');
            configureItem[1].checked = false;
            setPrice.innerText = '49zł';
        } else if(packageType === '12m') {
            configureItem[1].parentNode.classList.add('active');
            configureItem[1].checked = true;
            configureItem[0].parentNode.classList.remove('active');
            configureItem[0].checked = false;
            setPrice.innerText = '39zł';
        }
    } else {
        if(configureItem) {
            let status = false;
            for(var i = 0; i < configureItem.length; i++) {
                if(configureItem[i].checked) {
                    status = true;
                    configureItem[i].parentNode.classList.add('active');
                }
            }
    
            if(status === false) {
                if(configureItem[0]) {
                    configureItem[0].parentNode.classList.add('active');
                    configureItem[0].checked = true;
                }
            }
        }
    }

    if(configureLabels) {
        for(var i = 0; i < configureLabels.length; i++) {
            configureLabels[i].addEventListener('click',function() {
                for(var j = 0; j < configureLabels.length; j++) {
                    configureLabels[j].classList.remove('active');
                }

                this.classList.add('active');

                const inputValue = this.querySelector('input');

                if(inputValue) {
                    if(inputValue.value) {
                        if(inputValue.value === 'teleopieka_12m') {
                            changeSelectedPackage('rocznie');
                        } else if(inputValue.value === 'teleopieka_6m') {
                            changeSelectedPackage('polrocznie');
                        }
                    }
                }

                let getThePrice = this.getElementsByClassName('custom-item-price-top')[0];

                if(getThePrice) {
                    if(getThePrice.innerText.indexOf("49zł") !== -1) {
                        setPrice.innerText = '49zł';
                    } else if(getThePrice.innerText.indexOf("39zł") !== -1) {
                        setPrice.innerText = '39zł';
                    }
                }

            })
        }
    }

    const changeSelectedPackage = (e) => {
        const packageSelect = document.getElementById('pa_wybrany-pakiet');
        const option = packageSelect.querySelector(`option[value="${e}"]`);

        packageSelect.value = option.value;
    }

    const changeSelectedProduct = (e) => {
        const productSelect = document.getElementById('pa_produkt');
        const option = productSelect.querySelector(`option[value="${e}"]`);

        productSelect.value = option.value;
    }



    const generateProductLink = (e) => {

        const getPurchaseButton = document.querySelector('.product .single_add_to_cart_button');

        if(getPurchaseButton) {

        }

    }

    // Set second product as active:

    const configureItemBottom = document.querySelectorAll('.product-cf input');
    const configureLabelsBottom = document.querySelectorAll('.product-cf label');

    if(productType) {
        if(productType === 'bs.03') {
            configureItemBottom[0].nextElementSibling.classList.add('active');
            configureItemBottom[0].checked = true;
            configureItemBottom[1].nextElementSibling.classList.remove('active');
            configureItemBottom[1].checked = false;
        } else if(productType === 'bs.04') {
            configureItemBottom[1].nextElementSibling.classList.add('active');
            configureItemBottom[1].checked = true;
            configureItemBottom[0].nextElementSibling.classList.remove('active');
            configureItemBottom[0].checked = false;
        }
    } else {
        if(configureItemBottom) {
            let statusBottom = false;
            for(var i = 0; i < configureItemBottom.length; i++) {
                if(configureItemBottom[i].checked) {
                    statusBottom = true;
                    configureItemBottom[i].nextElementSibling.classList.add('active');
                }
            }

            if(statusBottom === false) {
                if(configureItemBottom[0]) {
                    configureItemBottom[0].nextElementSibling.classList.add('active');
                    configureItemBottom[0].checked = true;
                }
            }
        }
    }

    if(configureLabelsBottom) {
        for(var i = 0; i < configureLabelsBottom.length; i++) {
            configureLabelsBottom[i].addEventListener('click',function() {
                for(var j = 0; j < configureLabelsBottom.length; j++) {
                    configureLabelsBottom[j].classList.remove('active');
                }

                this.classList.add('active');
                const inputValue = this.previousElementSibling;

                if(inputValue) {
                    if(inputValue.value) {
                        if(inputValue.value === 'opaska_locon_life') {
                            changeSelectedProduct('bs-03');
                        } else if(inputValue.value === 'opaska_locon_life_plus') {
                            changeSelectedProduct('bs-04');
                        }
                    }
                }

            })
        }
    }

    // Generate html for products

    const buyProducts = document.querySelectorAll('.product-cf .woocommerce-input-wrapper label');

    if(buyProducts) {

        // Generate html for first element
        if(buyProducts[0]) {
            const mainWrapper = document.createElement('div');
            mainWrapper.classList.add('custom-product-text');
            buyProducts[0].appendChild(mainWrapper);
    
            const titleWrapper = document.createElement('div');
            titleWrapper.classList.add('custom-product-text__title');
            titleWrapper.innerText = 'Opaska dla pacjenta wymagającego opieki';
            mainWrapper.appendChild(titleWrapper);
    
            const priceWrapper = document.createElement('div');
            priceWrapper.classList.add('custom-product-text__price');
            priceWrapper.innerText = '399zł';
            mainWrapper.appendChild(priceWrapper);
    
            const descriptionWrapper = document.createElement('div');
            descriptionWrapper.classList.add('custom-product-text__description');
            descriptionWrapper.innerHTML = `
            <ul>
                <li>Teleopaska + Aplikacja + Opieka Centrum Ratownictwa i Monitoringu</li>
                <li>Szybka i precyzyjna lokalizacja GPS pacjenta</li>
                <li>Natychmiastowa reakcja w sytuacji zagrożenia zdrowia lub życia</li>
                <li>Zdalne pomiary czynności życiowych</li>
                <li>Dwa przyciski: wezwania pomocy oraz bezpośrednie nawiązanie połączenia z ratownikiem w Centrum Ratownictwa Medycznego Locon lub opiekunem.</li>
            </ul>
            
            `;
            mainWrapper.appendChild(descriptionWrapper);
    
            const btnWrapper = document.createElement('div');
            btnWrapper.classList.add('custom-product-text__btn','btn');
            btnWrapper.innerText = '';
            mainWrapper.appendChild(btnWrapper);
        }
        // Generate html for second element
        if(buyProducts[1]) {
            const mainWrapper = document.createElement('div');
            mainWrapper.classList.add('custom-product-text');
            buyProducts[1].appendChild(mainWrapper);
    
            const titleWrapper = document.createElement('div');
            titleWrapper.classList.add('custom-product-text__title');
            titleWrapper.innerText = 'Opaska dla aktywnego pacjenta';
            mainWrapper.appendChild(titleWrapper);
    
            const priceWrapper = document.createElement('div');
            priceWrapper.classList.add('custom-product-text__price');
            priceWrapper.innerText = '499zł';
            mainWrapper.appendChild(priceWrapper);
    
            const descriptionWrapper = document.createElement('div');
            descriptionWrapper.classList.add('custom-product-text__description');
            descriptionWrapper.innerHTML = `
            <ul>
                <li>Teleopaska + Aplikacja + Opieka Centrum Ratownictwa i Monitoringu</li>
                <li>Szybka i precyzyjna lokalizacja GPS pacjenta</li>
                <li>Natychmiastowa reakcja w sytuacji zagrożenia zdrowia lub życia</li>
                <li>Zdalne pomiary czynności życiowych</li>
                <li>Wyświetlacz LCD, jeden przycisk sterujący, dzięki któremu Twój bliski będzie mógł sam dokonać pomiarów ciśnienia, saturacji i temperatury.</li>
            </ul>
            `;
            mainWrapper.appendChild(descriptionWrapper);
    
            const btnWrapper = document.createElement('div');
            btnWrapper.classList.add('custom-product-text__btn','btn');
            btnWrapper.innerText = '';
            mainWrapper.appendChild(btnWrapper);
        }
    }

    const priceWrapperTop = document.querySelector('.fpf-field.fpf-email label');
    const priceWrapperBottom = document.querySelector('.fpf-field.fpf-number label')

    if(priceWrapperTop) {
        // Generate html with prices inside
        const mainWrapper = document.createElement('div');
        mainWrapper.classList.add('custom-item-price');
        priceWrapperTop.appendChild(mainWrapper);

        // Create promoPrice
        const promoPrice = document.createElement('span');
        promoPrice.classList.add('promo-price');
        promoPrice.innerText = '0 zł miesięcznie';
        mainWrapper.appendChild(promoPrice);

        // Create normalPrice

        const normalPrice = document.createElement('span');
        normalPrice.classList.add('normal-price');
        normalPrice.innerText = '39 zł miesięcznie';
        mainWrapper.appendChild(normalPrice);
    }

    if(priceWrapperBottom) {
        // Generate html with prices inside
        const mainWrapper = document.createElement('div');
        mainWrapper.classList.add('custom-item-price');
        priceWrapperBottom.appendChild(mainWrapper);

        // Create promoPrice
        const promoPrice = document.createElement('span');
        promoPrice.classList.add('promo-price');
        promoPrice.innerText = '0 zł miesięcznie';
        mainWrapper.appendChild(promoPrice);

        // Create normalPrice

        const normalPrice = document.createElement('span');
        normalPrice.classList.add('normal-price');
        normalPrice.innerText = '29 zł miesięcznie';
        mainWrapper.appendChild(normalPrice);
    }

    const pricesFirstBox = document.querySelectorAll('.product .fpf-field.fpf-radio label');

    if(pricesFirstBox) {
        if(pricesFirstBox[0]) {
            // Generate html with prices inside
            const mainWrapper = document.createElement('div');
            mainWrapper.classList.add('custom-item-price-top');
            mainWrapper.innerText = '49zł za miesiąc';
            pricesFirstBox[0].appendChild(mainWrapper);
        }

        if(pricesFirstBox[1]) {
            // Generate html with prices inside
            const mainWrapper = document.createElement('div');
            mainWrapper.classList.add('custom-item-price-top');
            mainWrapper.innerText = '39zł za miesiąc';
            pricesFirstBox[1].appendChild(mainWrapper);

        }
    }

    // Change product text inside first step

    const firstStepItemOne = document.getElementsByClassName('variation-Teleopiekanadspanclassbluepacjentemspan')[0];
    const secondStepItemOne = document.getElementsByClassName('variation-DostpdoaplikacjiAndroidiOS')[0];
    const thirdStepItemOne = document.getElementsByClassName('variation-Nielimitowanepoczeniatelefonicznezpacjentem')[0];
    const fourthStepItemOne = document.getElementsByClassName('variation-Urzdzeniespanclassbluepomiarowespan')[0];

    if(firstStepItemOne) {
        firstStepItemOne.innerHTML = 'Wybrany pakiet:';
    }

    if(secondStepItemOne) {
        secondStepItemOne.innerHTML = 'Adres email do aktywacji aplikacji:';
    }

    if(thirdStepItemOne) {
        thirdStepItemOne.innerHTML = 'Numer telefonu do aktywacji połączeń głosowych:';
    }

    if(fourthStepItemOne) {
        fourthStepItemOne.innerHTML = 'Wybrane urządzenie pomiarowe:';
    }


    // Submit form if click buttons in content

    const submitProductBtns = document.getElementsByClassName('single-product-add-to-cart-js');
    const singleProductForm = document.querySelector('.product .cart');

    if(submitProductBtns) {
        for(var i = 0; i < submitProductBtns.length; i++) {

            submitProductBtns[i].addEventListener('click', function() {

                // singleProductForm.submit();

            })

        }
    }








    // New Single product

    const packagesWrappers = document.getElementsByClassName('package-item-js');
    const productsWrappers = document.getElementsByClassName('product-item-js');

    if(packagesWrappers) {
        for(var i = 0; i < packagesWrappers.length; i++) {
            packagesWrappers[i].addEventListener('click', function() {
                for(var j = 0; j < packagesWrappers.length; j++) {
                    packagesWrappers[j].classList.remove('active');
                }

                this.classList.add('active');

                generateLink();
                generatePrices();
            })
        }
    }

    
    if(productsWrappers) {
        for(var i = 0; i < productsWrappers.length; i++) {
            productsWrappers[i].addEventListener('click', function() {
                for(var j = 0; j < productsWrappers.length; j++) {
                    productsWrappers[j].classList.remove('active');
                }

                this.classList.add('active');

                generateLink();
                generatePrices();
            })
        }
    }



    function generateLink() {
        const btnLink = document.getElementsByClassName('telecare-btn-js')[0];
        const getActivePackage = document.querySelector('.telecare-product__packages-item.active');
        const getActiveProduct = document.querySelector('.telecare-product__products-item.active');
        let packageTypes = '';
        let productTypes = '';
        let generatedLink = '';

        if(getActivePackage) {
            packageTypes = getActivePackage.dataset.packageType;
        }

        if(getActivePackage) {
            productTypes = getActiveProduct.dataset.productType;
        }

        if(productTypes == 'BS.03' && packageTypes == 'polrocznie') {
            generatedLink = 'https://zdrowie.bezpiecznarodzina.pl/koszyk?add-to-cart=1358';
        } else if(productTypes == 'BS.03' && packageTypes == 'rocznie') {
            generatedLink = 'https://zdrowie.bezpiecznarodzina.pl/koszyk?add-to-cart=1357';
        } else if(productTypes == 'BS.04' && packageTypes == 'polrocznie') {
            generatedLink = 'https://zdrowie.bezpiecznarodzina.pl/koszyk?add-to-cart=1355';
        } else if(productTypes == 'BS.04' && packageTypes == 'rocznie') {
            generatedLink = 'https://zdrowie.bezpiecznarodzina.pl/koszyk?add-to-cart=1356';
        }

        if(btnLink) {
            btnLink.href = generatedLink;
        }
    }

    function generatePrices() {
        const getActivePackage = document.querySelector('.telecare-product__packages-item.active');
        const getActiveProduct = document.querySelector('.telecare-product__products-item.active');
        const telePrice = document.getElementsByClassName('tele-price-js')[0];
        const productPrice = document.getElementsByClassName('product-price-js')[0];
        const sumPrice = document.getElementsByClassName('sum-price-js')[0];

        if(telePrice) {
            if(getActivePackage) {
                telePrice.innerHTML = getActivePackage.dataset.packagePrice + ' zł';
            }
        }

        if(productPrice) {
            if(getActiveProduct) {
                productPrice.innerHTML = getActiveProduct.dataset.productPrice + ' zł';
            }
        }

        if(sumPrice) {
            if(getActivePackage.dataset.packagePrice && getActiveProduct.dataset.productPrice) {
                sumPrice.innerHTML = (Number(getActiveProduct.dataset.productPrice) + Number(getActivePackage.dataset.packagePrice)) + ' zł';
            }
        }
    }

    const quantityWrappers = document.getElementsByClassName('product-quantity');

    if(quantityWrappers) {
        for(var i = 0; i < quantityWrappers.length; i++) {

            const quantityMinus = quantityWrappers[i].getElementsByClassName('minus')[0];
            const quantityPlus = quantityWrappers[i].getElementsByClassName('plus')[0];
            const quantityInput = quantityWrappers[i].querySelector('.quantity input');

            if(quantityInput) {
                quantityInput.addEventListener('change', function() {
                    if(Number(this.value) < 1) {
                        this.value = 1;
                    }
                })
            }
    
            if(quantityMinus) {
                quantityMinus.addEventListener('click', function() {
                    if(Number(quantityInput.value) > 1) {
                        quantityInput.value = Number(quantityInput.value) - 1;
                    }
                })
            }
    
            if(quantityPlus) {
                quantityPlus.addEventListener('click', function() {
                    quantityInput.value = Number(quantityInput.value) + 1;
                })
            }
                
        }
    }

    // setTimeout(() => {

    //     function makeEvents() {
    //         const quantityItem = document.querySelector('.quantity input');
    
    //         if(quantityItem) {
    //             quantityItem.addEventListener('input', clickHiddenButton);
    //             quantityItem.addEventListener('propertychange', clickHiddenButton);
    //             quantityItem.addEventListener('keydown', clickHiddenButton);
    //             quantityItem.addEventListener('paste', clickHiddenButton);
    //             quantityItem.addEventListener('change', clickHiddenButton);
    //         }
    //     }
    
    //     function clickHiddenButton() {
    //         const buttonToClick = document.querySelector('.woocommerce table.cart td.actions .button');
    
    //         console.log(buttonToClick);
    
    //         buttonToClick.click();
    //         setTimeout(() => {
    //             makeEvents();
    //         }, 1000);
    //     }

    //     makeEvents();
    // }, 500);

}

export default SingleProduct;